"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.LABEL_HEADER = exports.LABEL_CONTAINER = exports.LABEL = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../styles/vars"),
    LABEL = (0, _cxs["default"])({
  color: _vars.COLOURS.grey.regent,
  fontSize: _vars.FONT_SIZES.small,
  margin: 0,
  fontWeight: _vars.FONT_WEIGHTS.medium,
  letterSpacing: "1px",
  marginBottom: "3px",
  display: "block"
});

exports.LABEL = LABEL;
var LABEL_CONTAINER = (0, _cxs["default"])({
  textAlign: "left",
  width: "100%"
});
exports.LABEL_CONTAINER = LABEL_CONTAINER;
var LABEL_HEADER = (0, _cxs["default"])({
  display: "flex",
  justifyContent: "space-between"
});
exports.LABEL_HEADER = LABEL_HEADER;